import type { IconSvgObject } from './types';

const BorderFullIcon: IconSvgObject = [
  ["path", { d: "M5 22C3.89543 22 3 21.1046 3 20L3 4.00145C3 2.89631 3.89631 2.00065 5.00145 2.00145L19.0014 2.01158C20.1055 2.01237 21 2.90757 21 4.01157L21 20C21 21.1046 20.1046 22 19 22H5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M15 9.5H7M10.5556 14.5H7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default BorderFullIcon;
